import styled, { keyframes } from 'styled-components';

export const Bubble = styled.div`
  background-color: #f0f0f0;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;

  width: 49px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin: 8px 0;
`;

export const popAnimation = keyframes`
  0%   { transform: scale(0); }
  10%  { transform: scale(1); }
  70%  { transform: scale(1); }
  80%  { transform: scale(0); }
  100% { transform: scale(0); }
`;

export const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #000;
  transform: scale(0);
  animation: ${popAnimation} 2s infinite ease-in-out;
`;
